import { render, staticRenderFns } from "./AnswerContainer.vue?vue&type=template&id=52c2bb90&scoped=true&lang=pug&"
import script from "./AnswerContainer.vue?vue&type=script&lang=js&"
export * from "./AnswerContainer.vue?vue&type=script&lang=js&"
import style0 from "./AnswerContainer.vue?vue&type=style&index=0&id=52c2bb90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c2bb90",
  null
  
)

export default component.exports